module.exports = __webpack_public_path__ + "static/dataAnalytics-e1fdc80e6bd3aa980ba7ba758bbbcc80.jpg";